import React from 'react';
import Typography from '@material-ui/core/Typography';
import {useTranslation } from 'react-i18next';
import { Paper, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';


const DashboardView = () => {
  const { t } = useTranslation();
  const history = useHistory();

  history.push('/campaigns');

  return (
    <>
      <Paper elevation={1}>
        <Box p={4}>
          <Typography variant="h4">
            {t('dashboard')}
          </Typography>
        </Box>
      </Paper>
    </>
  );
};

export default DashboardView;
